// src/pages/Convocations/components/ConvocationActions.jsx

import React from "react";

import {
  FaCheckCircle,
  FaInfoCircle,
  FaTimesCircle,
} from "react-icons/fa";

import {
  cx,
  isEventUpcoming,
  normalizeResponseStatus,
} from "../utils/convocation.utils";

export default function ConvocationActions({
  convocation,
  saving,
  stacked = false,
  onOpenEvent,
  onRespond,
}) {
  const status =
    normalizeResponseStatus(
      convocation?.response_status,
    );

  const canRespond =
    isEventUpcoming(
      convocation?.Event,
    );

  return (
    <div
      className={cx(
        "flex gap-2",
        stacked
          ? "flex-col"
          : "flex-wrap",
      )}
    >
      <button
        type="button"
        onClick={() =>
          onOpenEvent(
            convocation?.Event,
          )
        }
        className={cx(
          [
            "inline-flex min-h-10",
            "items-center justify-center",
            "gap-2 rounded-xl",
            "border border-slate-200",
            "bg-white px-3",
            "text-xs font-semibold",
            "text-slate-700",
            "transition",
            "hover:border-blue-300",
            "hover:bg-blue-50",
            "hover:text-blue-700",
            "dark:border-slate-700",
            "dark:bg-slate-900",
            "dark:text-slate-200",
            "dark:hover:border-blue-700",
            "dark:hover:bg-blue-950/40",
            "dark:hover:text-blue-300",
          ].join(" "),
          stacked ? "w-full" : "",
        )}
      >
        <FaInfoCircle />

        Détails
      </button>

      {canRespond ? (
        <>
          <button
            type="button"
            onClick={() =>
              onRespond(
                convocation,
                "accepted",
              )
            }
            disabled={saving}
            className={cx(
              [
                "inline-flex min-h-10",
                "items-center justify-center",
                "gap-2 rounded-xl",
                "bg-emerald-600 px-3",
                "text-xs font-semibold",
                "text-white transition",
                "hover:bg-emerald-700",
                "active:scale-[0.98]",
                "disabled:cursor-wait",
                "disabled:opacity-60",
              ].join(" "),
              stacked
                ? "w-full"
                : "",
            )}
          >
            <FaCheckCircle />

            {status === "accepted"
              ? "Modifier"
              : "Accepter"}
          </button>

          <button
            type="button"
            onClick={() =>
              onRespond(
                convocation,
                "rejected",
              )
            }
            disabled={saving}
            className={cx(
              [
                "inline-flex min-h-10",
                "items-center justify-center",
                "gap-2 rounded-xl",
                "bg-rose-600 px-3",
                "text-xs font-semibold",
                "text-white transition",
                "hover:bg-rose-700",
                "active:scale-[0.98]",
                "disabled:cursor-wait",
                "disabled:opacity-60",
              ].join(" "),
              stacked
                ? "w-full"
                : "",
            )}
          >
            <FaTimesCircle />

            {status === "rejected"
              ? "Modifier"
              : "Refuser"}
          </button>
        </>
      ) : (
        <span
          className={cx(
            [
              "inline-flex min-h-10",
              "items-center justify-center",
              "rounded-xl",
              "bg-slate-100 px-3",
              "text-xs font-bold",
              "text-slate-500",
              "dark:bg-slate-800",
              "dark:text-slate-400",
            ].join(" "),
            stacked
              ? "w-full"
              : "",
          )}
        >
          Événement terminé
        </span>
      )}
    </div>
  );
}